import { Button } from "antd";
import { useTranslation } from "react-i18next";
interface button {
  onClick: any;
  disabled: any;
}

const NextButton = ({ onClick, disabled }: button) => {
  const [t] = useTranslation("common");

  return (
    <>
      <Button
        type="primary"
        size="large"
        style={{
          background: "#1677FF",
          color: "#fff",
          width: "120px",
          height: "40px",
        }}
        disabled={disabled}
        onClick={onClick}
      >
        {t("next")}
      </Button>
    </>
  );
};

export default NextButton;
